var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 14v18H4V14h4V8.16c0-1.13.2-2.2.6-3.18.42-1 .98-1.85 1.7-2.6.72-.73 1.56-1.3 2.54-1.74C13.8.2 14.86 0 16 0c1.14 0 2.2.2 3.16.64.98.43 1.82 1 2.54 1.75.72.7 1.28 1.6 1.7 2.55.4 1 .6 2.05.6 3.18V14h4zm-18 0h12V8.16c0-.85-.15-1.64-.45-2.4-.3-.73-.72-1.38-1.26-1.95-.58-.52-1.2-1-1.95-1.3-.72-.32-1.52-.5-2.37-.5-.86 0-1.66.18-2.4.5-.73.33-1.36.77-1.9 1.33-.54.6-.95 1.24-1.26 1.98-.3.76-.45 1.55-.45 2.4V14z","fillRule":"evenodd"}));
}

Lock.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Lock;

Lock.default = Lock;
